<template>
  <div class="site-footer">
    <a target="_blank" href="https://beian.miit.gov.cn/">京ICP备08100376号</a>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  components: {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.site-footer {
  background: #333333;
  height: 114px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 114px;
}
</style>
